module.exports = __webpack_public_path__ + "img/pattern.5dad50da.svg";